/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import {
  getSports,
  getAllGenericSportProperties,
} from '@sportninja/common/selectors/types'
import { useSelector } from 'src/hooks/useRedux'
import {
  PlayerProvider,
  usePlayerContext,
} from 'src/pages/Player/context/PlayerContext'
import { UIProvider } from 'src/pages/Player/context/UIContext'
import CareerStatsWidget from 'src/pages/Player/components/OverviewTab/CareerStatsWidget'
import CareerHighlightsWidget from 'src/pages/Player/components/OverviewTab/CareerHighlightsWidget'
import { useCareerStats } from 'src/pages/Player/hooks/useCareerStats'

interface Props {
  playerId: string
}

const outerColumnStyle = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`

const OverviewContent: React.FC = () => {
  const { state } = usePlayerContext()
  const { player, highlights } = state
  const history = useHistory()

  const sports = useSelector((s: any) => Object.values(getSports(s)))
  const genericSports = useSelector((s: any) => getAllGenericSportProperties(s))

  const { playerStats, goalieStats, statsLoading, isGenericSport, sportName } =
    useCareerStats(player, sports, genericSports)

  return (
    <div css={outerColumnStyle}>
      <CareerStatsWidget
        playerStats={playerStats}
        goalieStats={goalieStats}
        statsLoading={statsLoading}
        isGenericSport={isGenericSport}
        sportName={sportName}
        onViewAll={() => history.push(ROUTES.PROFILE.STATS)}
      />

      {highlights.length > 0 && (
        <CareerHighlightsWidget
          highlights={highlights}
          onViewAll={() => history.push(ROUTES.PROFILE.HIGHLIGHTS)}
        />
      )}
    </div>
  )
}

const OverviewTab: React.FC<Props> = ({ playerId }) => (
  <PlayerProvider playerId={playerId}>
    <UIProvider>
      <OverviewContent />
    </UIProvider>
  </PlayerProvider>
)

export default OverviewTab
